import React from 'react';
import { Container } from 'react-bootstrap';

const PrivacyPolicyPage = () => {
  return (
    <Container className="my-4">
      <h1>Política de Privacidad</h1>
      <p className="text-muted">Última actualización: 17 de octubre de 2026</p>

      <h2 className="mt-4">1. IDENTIDAD DEL RESPONSABLE DEL TRATAMIENTO</h2>
      <p>
        La presente Política de Privacidad establece los términos en que se tratan los datos personales recolectados a través de la plataforma Evazard.
      </p>
      <div>
        <strong>Razón Social:</strong> Jesús Antonio Castañeda Valencia<br />
        <strong>Marca Comercial:</strong> CValenciaIT<br />
        <strong>Plataforma:</strong> Evazard<br />
        <strong>Domicilio:</strong> Tuluá, Valle del Cauca, Colombia<br />
        <strong>Correo electrónico de contacto:</strong> cvalenciait.contacto@gmail.com
      </div>

      <h2 className="mt-4">2. ALCANCE</h2>
      <p>
        Esta política aplica a los datos personales que usted (el "Cliente" o "Usuario") nos proporciona directamente al registrarse, comprar una suscripción o utilizar nuestros servicios web.
      </p>

      <h2 className="mt-4">3. DATOS QUE RECOLECTAMOS</h2>
      <p>
        Para la prestación del servicio SaaS (Software as a Service), recolectamos los siguientes datos del Cliente:
      </p>
      <ul>
        <li><strong>Datos de Identificación:</strong> Nombre completo, número de identificación (Cédula/NIT), Razón Social del negocio.</li>
        <li><strong>Datos de Contacto:</strong> Dirección física, correo electrónico, número de teléfono.</li>
        <li><strong>Datos Financieros:</strong> Información necesaria para la facturación electrónica (si aplica) y gestión de pagos. Nota: No almacenamos códigos de seguridad (CVV) ni números completos de tarjetas de crédito; estos son procesados por pasarelas de pago certificadas.</li>
        <li><strong>Datos de Navegación:</strong> Dirección IP, tipo de dispositivo y registros de actividad (logs) para fines de seguridad y mejora del servicio.</li>
      </ul>

      <h2 className="mt-4">4. FINALIDAD DEL TRATAMIENTO</h2>
      <p>
        Tratamos sus datos personales para las siguientes finalidades:
      </p>
      <ul>
        <li>a) Proveer acceso a la plataforma Evazard y sus funcionalidades (POS, inventario, etc.).</li>
        <li>b) Gestionar la facturación, cobros y relaciones comerciales.</li>
        <li>c) Enviar notificaciones técnicas, actualizaciones de seguridad y soporte al cliente.</li>
        <li>d) Dar cumplimiento a obligaciones legales, contables y tributarias en Colombia.</li>
      </ul>

      <h2 className="mt-4">5. DERECHOS DE LOS TITULARES (HABEAS DATA)</h2>
      <p>
        De conformidad con la Ley 1581 de 2012, usted tiene derecho a:
      </p>
      <ul>
        <li>Conocer, actualizar y rectificar sus datos personales.</li>
        <li>Solicitar prueba de la autorización otorgada.</li>
        <li>Ser informado sobre el uso que se le ha dado a sus datos.</li>
        <li>Revocar la autorización y/o solicitar la supresión del dato cuando no se respeten los principios legales.</li>
        <li>Acceder en forma gratuita a sus datos personales.</li>
      </ul>
      <p>
        Para ejercer estos derechos, envíe una solicitud a cvalenciait.contacto@gmail.com.
      </p>

      <h2 className="mt-4">6. SEGURIDAD DE LA INFORMACIÓN</h2>
      <p>
        Implementamos medidas de seguridad técnicas (como cifrado SSL y contraseñas seguras) y administrativas para evitar la adulteración, pérdida, consulta o acceso no autorizado de su información.
      </p>
    </Container>
  );
};

export default PrivacyPolicyPage;
